import { render, staticRenderFns } from "./Localizacao.vue?vue&type=template&id=32163dde&scoped=true&"
import script from "./Localizacao.vue?vue&type=script&lang=ts&"
export * from "./Localizacao.vue?vue&type=script&lang=ts&"
import style0 from "./Localizacao.vue?vue&type=style&index=0&id=32163dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32163dde",
  null
  
)

export default component.exports